import React from "react"
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Label,
  Row,
  Toast,
  ToastBody,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import close from "../assets/images/icons/close.svg"
import BgPatternImage from "../assets/images/background-pattern.png"
import toast from "react-hot-toast"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useGetDocSignersQuery } from "store/api/signers/signers.api"

function ApproveWithSignerModal({
  data,
  open,
  setOpen,
  isLoading,
  title = "Approve Request",
  description = "Are you sure you want to approve request?",
  confirmButtonText = "Approve Request",
  onApprove,
  onSuccess,
  onClose,
}) {
  const validation = useFormik({
    initialValues: { signer: "" },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      handleSend(values)
    },
  })
  const { data: docSigners } = useGetDocSignersQuery()

  const handleSend = async (values) => {
    try {
      const { success, message } = await onApprove({
        ...data,
        ...values,
      }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toasterMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <div className="delete-card-wrapper">
                <div className="inner-box success">
                  <i className="mdi mdi-check-circle-outline"></i>
                </div>
                <div>
                  <h4>{title}</h4>
                  {description}
                </div>
                <div className="close-icon" onClick={() => setOpen(false)}>
                  <img src={close} alt="" />
                </div>
              </div>
              <Row>
                <Col xl={12}>
                  <Label className="col-form-label" htmlFor="signer">
                    Select Signatory
                    <span className="error">*</span>
                  </Label>
                  <select
                    id="signer"
                    name="signer"
                    className="form-select"
                    value={validation.values.signer}
                    onChange={validation.handleChange}
                  >
                    <option value=""> Select Signatory</option>
                    {docSigners?.data?.map((item, index) => (
                      <option key={`doc_signer_${index}`} value={item.phone_no}>
                        {item.name} ({item.phone_no})
                      </option>
                    ))}
                  </select>
                  {validation.errors.signer ? (
                    <FormFeedback type="invalid">
                      {validation.errors.signer}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>

              <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="cancel"
                >
                  Cancel
                </button>
                <Button className="approve btn btn-secondary" type="submit">
                  {isLoading ? <Spinners /> : confirmButtonText}
                </Button>
              </div>
            </Form>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default ApproveWithSignerModal
